<div class="wrapper">
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content>
        <p style="white-space: pre;">{{data.message}}</p>
        <div *ngIf="schools && schools.length > 0">
            <p>Este catálogo está asociado a estas escuelas:</p>
            <div *ngFor="let school of schools">
                <p>- {{school['name']}} </p>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false" *ngIf="!cancel">{{ 'buttons.cancel' | translate }}</button>
        <button mat-button [mat-dialog-close]="false" *ngIf="cancel">{{ 'buttons.no_cancel' | translate }}</button>
        <button mat-button [mat-dialog-close]="true" [disabled]="disableAccept">{{data.ok_txt}}</button>
    </div>
</div>